// B2BLanguagesMenu.js
import React from 'react';
import { AddCircle, Backspace, GitHub, Info, Label, LabelOff, ListAlt, Search, ViewList } from '@mui/icons-material';
import CustomMenu from '../layout/components/CustomMenu';
import useMenuItemClick from '../layout/hooks/useMenuItemClick';


const B2BLanguagesMenu = ({ handleLogout, onItemSelected = null }) => {
    const handleItemClick = useMenuItemClick(onItemSelected);

    const menuItems = [
        {
            label: 'Labels',
            icon: <Label />,
            items: [
                {
                    label: 'Find matching labels.',
                    icon: <Search />,
                    onClick: () => {
                        handleItemClick('/languages/labels');
                    },
                },
                {
                    label: 'Add a new label.',
                    icon: <AddCircle />,
                    onClick: () => {
                        handleItemClick('/languages/new');
                    },
                },
                {
                    label: 'Import CSV.',
                    icon: <ListAlt />,
                    onClick: () => {
                        handleItemClick('/languages/import-csv-file');
                    },
                },
            ],
        },
        {
            label: 'Not Found Labels',
            icon: <LabelOff />,
            items: [
                {
                    label: 'List of not found labels.',
                    icon: <ViewList />,
                    onClick: () => {
                        handleItemClick('/languages/labels-not-found');
                    },
                },
                { label: 'Clear not found list.', icon: <Backspace />, onClick: handleLogout },
            ],
        },
        {
            label: 'GIT Info',
            icon: <GitHub />,
            items: [
                {
                    label: 'Show GIT commit info.',
                    icon: <Info />,
                    onClick: () => {
                        handleItemClick('/languages/git-info');
                    },
                },
            ],
        },
    ];

    return (
        <CustomMenu title="Languages Menu"
            rolesAllowed={['ROLE_SUPER_ADMIN']}
            menuItems={menuItems} />
    );
};

export default B2BLanguagesMenu;
